
import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { PlusCircle, FileText } from "lucide-react";
import { useRecipeManager } from "./hooks/useRecipeManager";
import RecipeList from "./components/RecipeList";
import RecipeForm from "./RecipeForm";

const RecipeIdeasManager = () => {
  const navigate = useNavigate();
  const {
    filteredRecipes,
    isLoading,
    searchTerm,
    setSearchTerm,
    selectedRecipe,
    viewMode,
    handleCreateRecipe,
    handleEditRecipe,
    handleDeleteRecipe,
    handleSaveRecipe,
    handleBackToList
  } = useRecipeManager();

  return (
    <div className="space-y-6">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
        <div>
          <h1 className="text-2xl font-bold">Holiday Recipes</h1>
          <p className="text-gray-500">
            Manage recipe ideas for the Recipe Generator tool
          </p>
        </div>
        <div className="flex gap-2">
          <Button
            variant="outline"
            onClick={() => navigate("/admin/tools/recipe-importer")}
            className="flex items-center gap-1"
          >
            <FileText size={16} />
            Import Recipes
          </Button>
          <Button
            onClick={handleCreateRecipe}
            className="bg-elfGreen hover:bg-elfGreen-dark flex items-center gap-1"
          >
            <PlusCircle size={16} />
            Add New Recipe
          </Button>
        </div>
      </div>

      {viewMode === "list" ? (
        <RecipeList
          recipes={filteredRecipes}
          isLoading={isLoading}
          searchTerm={searchTerm}
          onSearchChange={setSearchTerm}
          onEdit={handleEditRecipe}
          onDelete={handleDeleteRecipe}
        />
      ) : (
        <RecipeForm
          recipe={selectedRecipe}
          onSave={handleSaveRecipe}
          onCancel={handleBackToList}
        />
      )}
    </div>
  );
};

export default RecipeIdeasManager;
